import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/Sidebar.css";
import Icons from "../components/icons";
import "bootstrap/dist/css/bootstrap.min.css";
import Logo from "../assets/img/Logo.png";
import Logo2 from "../assets/img/Logo2.png";
import { jwtDecode } from "jwt-decode";

function Sidebar({ isSidebarOpen }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSalesAdminUser, setIsSalesAdminUser] = useState(false);
  const [isSuperAdminUser, setIsSuperAdminUser] = useState(false);

  // Function to decode JWT and get admin info
  const getAdminInfo = () => {
    try {
      const adminToken = localStorage.getItem("adminToken");
      if (adminToken) {
        const decodedToken = jwtDecode(adminToken);
        return {
          email: decodedToken.email,
          role: decodedToken.role
        };
      }
    } catch (error) {
      console.error("Error decoding admin token:", error);
    }
    return null;
  };

  useEffect(() => {
    const adminInfo = getAdminInfo();
    if (adminInfo) {
      setIsSalesAdminUser(adminInfo.email === "");
      setIsSuperAdminUser(adminInfo.role === "superadmin");
    } else {
      setIsSalesAdminUser(false);
      setIsSuperAdminUser(false);
    }
  }, [location.pathname]); // Re-check when route changes

  useEffect(() => {
    if (isSalesAdminUser) {
      if (
        location.pathname !== "/admin/sales-report" &&
        location.pathname !== "/admin/logout"
      ) {
        navigate("/admin/sales-report", { replace: true });
      }
    }
  }, [isSalesAdminUser, location.pathname, navigate]);

  const handleLogout = async () => {
    try {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("remember_token");

      document.cookie =
        "admin_token=; Max-Age=0; path=/; domain=" + window.location.hostname;
      document.cookie =
        "remember_token=; Max-Age=0; path=/; domain=" + window.location.hostname;

      navigate("/admin/login", { replace: true });

      setTimeout(() => {
        window.history.replaceState(null, "", "/admin/login");
      }, 100);
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };


  return (
    <>
      <aside
        className={`main-sidebar sidebar-collapse account-side-menu ${isSidebarOpen ? "open" : "closed"
          }`}
      >
        <Link to="#" className="brand-link">
          <img className="asm-main-logo" src={Logo} alt="Logo" />
        </Link>
        <div className="sidebar">
          <nav className="mt-2-nav">
            <ul className="nav nav-pills nav-sidebar flex-column">
              {/* Conditionally render all links for Non-Sales Admins */}
              {!isSalesAdminUser && (
                <>
                  <li className="nav-item">
                    <Link
                      to="/admin/dashboard"
                      className={`nav-link ${location.pathname === "/admin/dashboard" ? "active" : ""
                        }`}
                    >
                      <Icons.SvgIcon />
                      <p
                        className={`sidebar-text ${isSidebarOpen ? "visible" : "hidden"
                          }`}
                      >
                        Dashboard
                      </p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/admin/providers"
                      className={`nav-link ${location.pathname === "/admin/providers"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Icons.PlusIcon />
                      <p>Provider</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/admin/bloglist"
                      className={`nav-link ${location.pathname === "/admin/bloglist"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Icons.PlusIcon />
                      <p>Blogs</p>
                    </Link>
                  </li>
                  {/* Show Admin menu only for Super Admin */}
                  {isSuperAdminUser && (
                    <li className="nav-item">
                      <Link
                        to="/admin/user"
                        className={`nav-link ${location.pathname === "/admin/user" ? "active" : ""
                          }`}
                      >
                        <Icons.UserIcon />
                        <p>Admin</p>
                      </Link>
                    </li>
                  )}
                  <li className="nav-item">
                    <Link
                      to="/admin/transactions"  // transactions =>>>> trash  
                      className={`nav-link ${location.pathname === "/admin/transactions" ? "active" : ""
                        }`}
                    >
                      <Icons.ChartBarSvg />
                      <p>Trash</p>   
                    </Link>
                  </li>
                  {/* Claim Requests Link */}
                  <li className={`nav-item ${location.pathname.startsWith('/admin/claims') ? 'active' : ''}`}>
                    <Link to="/admin/claims" className="nav-link">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                          <path d="m9 12 2 2 4-4"></path>
                      </svg>
                      <p>Claim Requests</p>
                    </Link>
                  </li>
                  <li className={`nav-item ${location.pathname.startsWith('/admin/contact-inquiries') ? 'active' : ''}`}>
                    <Link to="/admin/contact-inquiries" className="nav-link">
                      <Icons.ContactIcon />
                      <p>Contact Inquiries</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/admin/settings"
                      className={`nav-link ${location.pathname === "/admin/settings" ? "active" : ""
                        }`}
                    >
                      <Icons.SettingIcon />
                      <p>Settings</p>
                    </Link>
                  </li>
                
                  
                </>
              )}

              {/* Show Sales Report only if it's the Sales Admin */}
              {isSalesAdminUser && (
                <li className="nav-item">
                  <Link
                    to="/admin/sales-report"
                    className={`nav-link ${location.pathname === "/admin/sales-report"
                      ? "active"
                      : ""
                      }`}
                  >
                    <Icons.SalesReportIcon />
                    <p>Sales Report</p>
                  </Link>
                </li>
              )}

              {/* Logout is always visible */}
              <li className="nav-item">
                <button
                  onClick={handleLogout}
                  className={`nav-link btn-link ${location.pathname === "/admin/logout" ? "active" : ""
                    }`}
                >
                  <Icons.LogoutIcon />
                  <p>Logout</p>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </aside>

      {/* Collapsed Sidebar - Apply the same logic here */}
      {!isSidebarOpen && (
        <aside className="main-sidebar account-side-menu min-sidebar">
          <Link to="#" className="brand-link">
            <img
              className="asm-logo-icon1 img-visible1"
              src={Logo2}
              alt="Icon"
            />
            <img className="asm-main-logo img-visible" src={Logo} alt="Logo" />
          </Link>
          <div className="sidebar">
            <nav className="mt-2-nav">
              <ul className="nav nav-pills nav-sidebar flex-column">
                {/* Conditionally render all links for Non-Sales Admins (collapsed) */}
                {!isSalesAdminUser && (
                  <>
                    <li className="nav-item">
                      <Link
                        to="/admin/dashboard"
                        className={`nav-link ${location.pathname === "/admin/dashboard"
                          ? "active1"
                          : ""
                          }`}
                      >
                        <Icons.SvgIcon />
                        <p className="text-visible">Dashboard</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/admin/providers"
                        className={`nav-link ${location.pathname === "/admin/providers"
                          ? "active1"
                          : ""
                          }`}
                      >
                        <Icons.PlusIcon />
                        <p className="text-visible">Provider</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/admin/bloglist"
                        className={`nav-link ${location.pathname === "/admin/bloglist"
                          ? "active1"
                          : ""
                          }`}
                      >
                        <Icons.PlusIcon />
                        <p className="text-visible">Blogs</p>
                      </Link>
                    </li>
                    {/* Show Admin menu only for Super Admin (collapsed) */}
                    {isSuperAdminUser && (
                      <li className="nav-item">
                        <Link
                          to="/admin/user"
                          className={`nav-link ${location.pathname === "/admin/user" ? "active1" : ""
                            }`}
                        >
                          <Icons.UserIcon />
                          <p className="text-visible">Admin</p>
                        </Link>
                      </li>
                    )}
                    <li className="nav-item">
                      <Link
                        to="/admin/transactions"
                        className={`nav-link ${location.pathname === "/admin/transactions"
                          ? "active1"
                          : ""
                          }`}
                      >
                        <Icons.ChartBarSvg />
                        <p className="text-visible">Trash</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/admin/contact-inquiries"
                        className={`nav-link ${location.pathname === "/admin/contact-inquiries"
                          ? "active1"
                          : ""
                          }`}
                      >
                        <Icons.ContactIcon />
                        <p className="text-visible">Contact Inquiries</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/admin/settings"
                        className={`nav-link ${location.pathname === "/admin/settings"
                          ? "active1"
                          : ""
                          }`}
                      >
                        <Icons.SettingIcon />
                        <p className="text-visible">Settings</p>
                      </Link>
                    </li>

                    {/* Sales Report for Super Admin here (collapsed) */}
                    {isSuperAdminUser && (
                      <li className="nav-item">
                        <Link
                          to="/admin/sales-report"
                          className={`nav-link ${location.pathname === "/admin/sales-report"
                            ? "active1"
                            : ""
                            }`}
                        >
                          <Icons.SalesReportIcon />
                          <p className="text-visible">Sales Report</p>
                        </Link>
                      </li>
                    )}
                  </>
                )}

                {/* Show Sales Report only if it's the Sales Admin (collapsed) */}
                {isSalesAdminUser && (
                  <li className="nav-item">
                    <Link
                      to="/admin/sales-report"
                      className={`nav-link ${location.pathname === "/admin/sales-report"
                        ? "active1"
                        : ""
                        }`}
                    >
                      <Icons.SalesReportIcon />
                      <p className="text-visible">Sales Report</p>
                    </Link>
                  </li>
                )}
                {/* Logout is always visible (collapsed) */}
                <li className="nav-item">
                  <Link
                    to="/admin/logout"
                    className={`nav-link ${location.pathname === "/admin/logout" ? "active1" : ""
                      }`}
                  >
                    <Icons.LogoutIcon />
                    <p className="text-visible">Logout</p>
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </aside>
      )}
    </>
  );
}

export default Sidebar;
